






import Vue from "vue";

export default Vue.extend({
  name: "cwx-card",

  data() {
    return {
      hover: false as boolean
    };
  }
});
